/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbFormateurDiplomeGridDto
 */
export interface FcbFormateurDiplomeGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurDiplomeGridDto
     */
    iddiplome?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurDiplomeGridDto
     */
    idformateur?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbFormateurDiplomeGridDto
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbFormateurDiplomeGridDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbFormateurDiplomeGridDto
     */
    date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof FcbFormateurDiplomeGridDto
     */
    url?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurDiplomeGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbFormateurDiplomeGridDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the FcbFormateurDiplomeGridDto interface.
 */
export function instanceOfFcbFormateurDiplomeGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurDiplomeGridDtoFromJSON(json: any): FcbFormateurDiplomeGridDto {
    return FcbFormateurDiplomeGridDtoFromJSONTyped(json, false);
}

export function FcbFormateurDiplomeGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurDiplomeGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iddiplome': !exists(json, 'iddiplome') ? undefined : json['iddiplome'],
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'date': !exists(json, 'date') ? undefined : (json['date'] === null ? null : new Date(json['date'])),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function FcbFormateurDiplomeGridDtoToJSON(value?: FcbFormateurDiplomeGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iddiplome': value.iddiplome,
        'idformateur': value.idformateur,
        'type': value.type,
        'libelle': value.libelle,
        'date': value.date === undefined ? undefined : (value.date === null ? null : value.date.toISOString()),
        'url': value.url,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
    };
}

